import React from 'react'

const About = () => {
  return(
    <div className="card">
      <h2 className="about-headers">What is Audio Description?</h2>
        <h3>
          Audio Description (AD) is a service that describes visual aspects of a show or performance for blind or visually impaired persons. In a live theater setting, the description is said live, not previously recorded like you might experience with a movie or TV show.
        <br/><br/>
          AD allows low vision or blind patrons to fully experience the arts. Trained describers describe facial expressions, entrance and exit of characters, action on stage and other visual information to listeners. Before the performance begins, a describer will describe details of scenery, costumes, and other information about the performance and venue.
        </h3>
      <h2 className="about-headers">What is DASI?</h2>
        <h3>
          Descriptive Audio for the Sight Impaired, or DASI, is the primary provider of AD in the Asheville, NC area. We are a non-profit organization that is not affiliated with just one theater. We own our own equipment (receivers, microphone, and transmitter) so we are portable and can describe in any theater or venue for which a request is made.
        </h3>
      <h2 className="about-headers">How does AD work?</h2>
        <h3>
          Listeners receive a small hand held wireless receiver and earpiece to listen to AD upon arrival at the theater. This discrete system allows only the listener to hear the AD without disturbing other patrons around them. The earpieces work with most hearing aids. Typically, describers are in the back of the theater with a masked microphone and transmitter. This system also allows those around the describer to not be disturbed, either.
          <br/><br/>
          It is FREE to listen! There is no charge to the listener to use DASI's services. All you have to pay for is your tickets to the performance itself. Ask your local theater if they offer AD. If not, please request it and have them contact the DASI president to make arrangements.
        </h3>
    </div>
    )
}

export default About;